var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tsmanifestMain",staticClass:"tsmanifestMain",style:({ 
  'width': '100%',
  'height': '100%',
  'position': 'relative'})},[_c('div',{staticClass:"truckManifestHeader",style:({
    'width': ((738 * _vm.zoomLevel) + 'px'),
    'height': ((57 * _vm.zoomLevel) + 'px'),
    'position': 'absolute',
    'top': (((3 * _vm.zoomLevel) + 18) + 'px'),
    'left': ((39 * _vm.zoomLevel) + 'px'), })},[_c('div',{staticClass:"TMSJINo",style:({
      'width': ((130 * _vm.zoomLevel) + 'px'),
      'height': ((30 * _vm.zoomLevel) + 'px'),
      'font-size': ((20 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((15 * _vm.zoomLevel) + 'px'),
      'right': '33px', 
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-end'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['JHTMSJINO'] ? _vm.properties['details']['JHTMSJINO'] : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'TMSJINo')+"\n    ")]),_c('div',{staticClass:"pageNo",style:({
      'width': ((130 * _vm.zoomLevel) + 'px'),
      'height': ((30 * _vm.zoomLevel) + 'px'),
      'font-size': ((13 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((33 * _vm.zoomLevel) + 'px'),
      'right': '33px', 
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-end'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['jobs'] ? (_vm.properties['jobs'][0]['page'] ? _vm.properties['jobs'][0]['page'] : '') : '') : '')+" page\n      "+_vm._s(_vm.print ? '' : 'pageNo')+"\n    ")]),_c('div',{staticClass:"date",style:({
      'width': ((110 * _vm.zoomLevel) + 'px'),
      'height': ((20 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((18 * _vm.zoomLevel) + 'px'),
      'right': ((220 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['JHDateIssued'] ? _vm.properties['details']['JHDateIssued'] : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'date')+"\n    ")]),_c('div',{staticClass:"day",style:({
      'width': ((110 * _vm.zoomLevel) + 'px'),
      'height': ((20 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((36 * _vm.zoomLevel) + 'px'),
      'right': ((220 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['JHDay'] ? _vm.properties['details']['JHDay'] : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'day')+"\n    ")])]),_vm._l((3),function(j,i){return _c('div',{key:'job' + i,staticClass:"truckManifestMain",style:({ 
    'width': ((738 * _vm.zoomLevel) + 'px'),
    'height': ((248 * _vm.zoomLevel) + 'px'),
    'position': 'absolute',
    'top': (((90 + (268 * i)) * _vm.zoomLevel) + 'px'),
    'left': ((39 * _vm.zoomLevel) + 'px'), })},[_c('div',{staticClass:"destCode",style:({
      'width': ((30 * _vm.zoomLevel) + 'px'),
      'height': ((20 * _vm.zoomLevel) + 'px'),
      'text-align': 'center',
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((40 * _vm.zoomLevel) + 'px'),
      'left': ((0 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'center'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['jobs'] ? (_vm.properties['jobs'][i] ? (_vm.properties['jobs'][i]['DestinationCode'] ? _vm.properties['jobs'][i]['DestinationCode'] : '') : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'destCode')+"\n    ")]),_c('div',{staticClass:"seqNo",style:({
      'width': ((30 * _vm.zoomLevel) + 'px'),
      'height': ((20 * _vm.zoomLevel) + 'px'),
      'text-align': 'center',
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((70 * _vm.zoomLevel) + 'px'),
      'left': ((0 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'center'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['jobs'] ? (_vm.properties['jobs'][i] ? (_vm.properties['jobs'][i]['DropSeqNo'] ? ('Drop ' + (_vm.properties['jobs'][i]['DropSeqNo'])) : '') : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'seqNo')+"\n    ")]),((_vm.properties && _vm.properties['jobs'][i] && _vm.properties['jobs'][i]['Consignment']) || !_vm.print)?_c('div',{staticClass:"ist",style:({
      'width': ((140 * _vm.zoomLevel) + 'px'),
      'height': ((120 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((20 * _vm.zoomLevel) + 'px'),
      'left': ((45 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'flex-direction': 'column',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._l(((_vm.print ? (_vm.properties['jobs'][i]['Consignment']) : [])),function(c,i2){return _c('div',{key:'ist' + i2,staticClass:"istDetails",style:({
        'width': '100%',
        'height': ((12 * _vm.zoomLevel) + 'px'),
        'font-size': ((14 * _vm.zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'})},[_vm._v("\n        "+_vm._s(c['IST No'] ? c['IST No'] : '0')+"\n      ")])}),_vm._v("\n      "+_vm._s(_vm.print ? '' : 'istNo')+"\n    ")],2):_vm._e(),((_vm.properties && _vm.properties['jobs'][i] && _vm.properties['jobs'][i]['Consignment']) || !_vm.print)?_c('div',{staticClass:"truckManifest",style:({
      'width': ((115 * _vm.zoomLevel) + 'px'),
      'height': ((120 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((20 * _vm.zoomLevel) + 'px'),
      'left': ((215 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'flex-direction': 'column',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._l(((_vm.print ? (_vm.properties['jobs'][i]['Consignment']) : [])),function(c,i2){return _c('div',{key:'truck' + i2,staticClass:"truckDetails",style:({
        'width': '100%',
        'height': ((12 * _vm.zoomLevel) + 'px'),
        'font-size': ((14 * _vm.zoomLevel) + 'px'),
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'flex-start'})},[_vm._v("\n        "+_vm._s(c['Manifest No'] ? c['Manifest No'] : '0')+"\n      ")])}),_vm._v("\n      "+_vm._s(_vm.print ? '' : 'manifestNo')+"\n    ")],2):_vm._e(),_c('div',{staticClass:"scanCode",style:({
      'width': ((55 * _vm.zoomLevel) + 'px'), //110
      'height': ((55 * _vm.zoomLevel) + 'px'), //110
      'background-size': ((55 * _vm.zoomLevel) + 'px'), //110
      'background-repeat': 'no-repeat',
      'background-position': 'center',
      'position': 'absolute',
      'top': ((20 * _vm.zoomLevel) + 'px'), //24
      'left': ((280 * _vm.zoomLevel) + 'px'),
      //'right': ((8 * zoomLevel) + 'px'), 
      'display': 'flex',
      'flex-direction': 'column',
      'align-items': 'center',
      'justify-content': 'flex-start'}),attrs:{"id":_vm.properties ? (_vm.properties['jobs'] ? (_vm.properties['jobs'][i] ? (_vm.properties['jobs'][i]['Consignment'] ? (_vm.properties['jobs'][i]['Consignment'][0] ? (_vm.properties['jobs'][i]['Consignment'][0]['ConsignmentNo'] ? _vm.properties['jobs'][i]['Consignment'][0]['ConsignmentNo'].trim() : '') : '') : '') : '') : '') : ''}},[_vm._v("\n      "+_vm._s(_vm.print ? '' : 'scanCode')+"\n    ")]),_c('div',{staticClass:"company",style:({
      'width': ((172 * _vm.zoomLevel) + 'px'),
      'height': ((40 * _vm.zoomLevel) + 'px'),
      'line-height': ((14 * _vm.zoomLevel) + 'px'),
      'font-size': ((12 * _vm.zoomLevel) + 'px'),
      'font-weight': 'bold',
      'position': 'absolute',
      'top': ((24 * _vm.zoomLevel) + 'px'),
      'left': ((430 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'flex-start',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['jobs'] ? (_vm.properties['jobs'][i] ? (_vm.properties['jobs'][i]['DestinationName'] ? _vm.properties['jobs'][i]['DestinationName'] : '') : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'company')+"\n    ")]),_c('div',{staticClass:"address",style:({
      'width': ((286 * _vm.zoomLevel) + 'px'),
      'height': ((68 * _vm.zoomLevel) + 'px'),
      'line-height': ((14 * _vm.zoomLevel) + 'px'),
      'font-size': ((12 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((79 * _vm.zoomLevel) + 'px'),
      'left': ((430 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'flex-start',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['jobs'] ? (_vm.properties['jobs'][i] ? (_vm.properties['jobs'][i]['DestinationAddress'] ? _vm.properties['jobs'][i]['DestinationAddress'] : '') : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'address')+"\n    ")]),_c('div',{staticClass:"TMSWithPage",style:({
      'width': ((286 * _vm.zoomLevel) + 'px'),
      'height': ((24 * _vm.zoomLevel) + 'px'),
      'font-size': ((12 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'bottom': '20px',
      'left': ((425 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-end'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['JHTMSJINO'] ? _vm.properties['details']['JHTMSJINO'] : '') : '') : '')+" \n      Page "+_vm._s(_vm.properties ? (_vm.properties['jobs'] ? (_vm.properties['jobs'][0]['page'] ? _vm.properties['jobs'][0]['page'] : '') : '') : '')+" ("+_vm._s(i + 1)+"/3)\n      "+_vm._s(_vm.print ? '' : 'jobNo')+" \n    ")]),_c('div',{staticClass:"jobNo",style:({
      'width': ((172 * _vm.zoomLevel) + 'px'),
      'height': ((24 * _vm.zoomLevel) + 'px'),
      'font-size': ((16 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'bottom': '0px',
      'right': '0px',
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['jobs'] ? (_vm.properties['jobs'][i] ? (_vm.properties['jobs'][i]['JobNo'] ? _vm.properties['jobs'][i]['JobNo'] : '') : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'jobNo')+"\n    ")])])}),_c('div',{staticClass:"truckManifestGatepass",style:({ 
    'width': ((738 * _vm.zoomLevel) + 'px'),
    'height': ((176 * _vm.zoomLevel) + 'px'),
    'position': 'absolute',
    'bottom': (((20 * _vm.zoomLevel) + 20) + 'px'),
    'left': ((39 * _vm.zoomLevel) + 'px'), })},[_c('div',{staticClass:"lorryNo",style:({
      'width': ((205 * _vm.zoomLevel) + 'px'),
      'height': ((16 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((19 * _vm.zoomLevel) + 'px'),
      'left': ((140 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['Lorry_No'] ? _vm.properties['details']['Lorry_No'] : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'lorryNo')+"\n    ")]),_c('div',{staticClass:"vehicleCode",style:({
      'width': ((205 * _vm.zoomLevel) + 'px'),
      'height': ((16 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((33 * _vm.zoomLevel) + 'px'),
      'left': ((140 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['JHVehicleCode'] ? _vm.properties['details']['JHVehicleCode'] : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'vehicleCode')+"\n    ")]),_c('div',{staticClass:"driverName",style:({
      'width': ((205 * _vm.zoomLevel) + 'px'),
      'height': ((16 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((60 * _vm.zoomLevel) + 'px'),
      'left': ((140 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['DriverName'] ? _vm.properties['details']['DriverName'] : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'driverName')+"\n    ")]),_c('div',{staticClass:"NRIC",style:({
      'width': ((205 * _vm.zoomLevel) + 'px'),
      'height': ((16 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((87 * _vm.zoomLevel) + 'px'),
      'left': ((140 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['EStaff_NRIC'] ? _vm.properties['details']['EStaff_NRIC'] : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'NRIC')+"\n    ")]),_c('div',{staticClass:"mobileNo",style:({
      'width': ((205 * _vm.zoomLevel) + 'px'),
      'height': ((16 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((115 * _vm.zoomLevel) + 'px'),
      'left': ((140 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['EStaff_MobileNo'] ? _vm.properties['details']['EStaff_MobileNo'] : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'mobileNo')+"\n    ")]),_c('div',{staticClass:"ownership",style:({
      'width': ((205 * _vm.zoomLevel) + 'px'),
      'height': ((16 * _vm.zoomLevel) + 'px'),
      'font-size': ((14 * _vm.zoomLevel) + 'px'),
      'position': 'absolute',
      'top': ((140 * _vm.zoomLevel) + 'px'),
      'left': ((140 * _vm.zoomLevel) + 'px'),
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start'})},[_vm._v("\n      "+_vm._s(_vm.properties ? (_vm.properties['details'] ? (_vm.properties['details']['OwnerShip'] ? _vm.properties['details']['OwnerShip'] : '') : '') : '')+"\n      "+_vm._s(_vm.print ? '' : 'ownership')+"\n    ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }